import {IRestrictionsService} from "./restrictions.service.interface";
import {ServiceBase} from "../ServiceBase";

export class RestrictionsService extends ServiceBase implements IRestrictionsService {
    getGenericRestrictionMessage(): string {
        return this.services.translation.translate('100200');
    }
}